import React from "react";

const AddGiornoCard = ({ cammino, onAddClick }) => {
    return (
        <div
            style={{
                position: "relative",
                width: "33%",
                marginBottom: "20px",
                minHeight: "160px",
                padding: "5px",
            }}
            key={cammino.id}
        >
            <div
                className="div-cammini"
                style={{
                    cursor: "pointer",
                    display: "flex",
                    backgroundColor: "#B1B1B1",
                    color: "#fff",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    padding: "5px",
                    boxShadow: "0px 3px 6px #00000029",
                    borderRadius: "20px",
                    marginTop: "0px",
                    marginBottom: "20px",
                    minHeight: "220px",
                }}
            >
                <div onClick={onAddClick}>
                    <p
                        style={{
                            textAlign: "center",
                            fontSize: "1.5em",
                            fontWeight: "100",
                            marginBottom: "5px",
                            lineHeight: "1em",
                        }}
                    >
                        +
                    </p>
                    <p style={{ fontWeight: "bold" }}>Aggiungi giorno</p>
                </div>
            </div>
        </div>
    );
};

export default AddGiornoCard;